/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.userType === 'admin',
    onlyUser: currentUser && currentUser.userType === 'artist',
    canUser: currentUser && (currentUser.userType === 'admin' || currentUser.userType === 'artist'),
  };
}
